import moment from "moment";
import { isoDateFormat, displayDateFormat } from "../helpers/dateUtils";

const validate = (value, { format = isoDateFormat }) => {
  return moment(value, format, true).isValid();
}

const getMessage = (field) => {
  return "The " + field + " value must be in the format " + displayDateFormat + ".";
}

const paramNames = [ "format" ];

export default {
  getMessage,
  validate,
  paramNames
}